export const colorsPalette = {
  transparent: 'transparent',
  black: '#393939',
  brown10: '#f4f3f0',
  brown20: '#efede9',
  brown100: '#857871',
  brown40: '#d5d0c4',
  grey: '#393939',
  grey10: '#eef0f2',
  grey20: '#d9dbdd',
  grey40: '#a2a2a2',
  grey50: '#858585',
  grey60: '#747475',
  grey80: '#656566',
  grey90: '#4d4d4d',
  grey110: '#333333',
  red: '#e52500',
  red10: '#fce9e6',
  red20: '#fad3cc',
  red40: '#f5a899',
  red60: '#ef7C66',
  red80: '#ea5133',
  red110: '#d42705',
  red120: '#c3290b',
  red140: '#a02d17',
  red160: '#7e3122',
  red180: '#5b352e',
  teal: '#008385',
  teal10: '#e6f3f4',
  teal20: '#cce8e8',
  teal40: '#99d1d1',
  teal60: '#66b9bb',
  teal80: '#33a2a4',
  teal120: '#0b707c',
  teal140: '#176a6b',
  teal160: '#225a5b',
  teal180: '#2e494a',
  white: '#ffffff',
  tint: '#888888',
  tintgrey: '#616161',
};

export const keyColors = Object.keys(colorsPalette).reduce((accum, current) => {
  return { ...accum, [current]: current };
}, {});

export const hexToRgba = (hex, alpha = 1) => {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    const hexList = hex.substring(1).split('');
    const fullHexadecimal =
      hexList.length === 3
        ? [
            hexList[0],
            hexList[0],
            hexList[1],
            hexList[1],
            hexList[2],
            hexList[2],
          ]
        : hexList;

    const hexColor = `0x${fullHexadecimal.join('')}`;
    const red = (hexColor >> 16) & 255;
    const green = (hexColor >> 8) & 255;
    const blue = hexColor & 255;

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  }

  return hex;
};

export const shadows = {
  shadow40: '0px 5px 20px rgba(0, 0, 0, 0.12)',
  shadow80: '0px 10px 80px rgba(0, 0, 0, 0.08)',
};
